/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNumberList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4.736 15.698v.618l-1.032 1.056c.388.044.687.179.897.405s.315.509.315.849c0 .3-.068.559-.204.777s-.331.385-.585.501-.555.174-.903.174c-.228 0-.448-.023-.66-.069s-.4-.113-.564-.201v-.798a2.742 2.742 0 0 0 1.188.282c.284 0 .502-.058.654-.174s.228-.282.228-.498c0-.204-.059-.362-.177-.474s-.291-.168-.519-.168a1.71 1.71 0 0 0-.612.114l-.294-.492 1.08-1.14h-1.47v-.762zM22 17v2H7v-2zM3.362 9.62c.464 0 .824.106 1.08.318.256.212.384.514.384.906 0 .16-.032.32-.096.48s-.169.339-.315.537-.343.435-.591.711l-.606.666h1.62V14H2v-.63l1.092-1.2c.212-.232.377-.421.495-.567s.201-.27.249-.372.072-.197.072-.285c0-.364-.23-.546-.69-.546-.324 0-.692.11-1.104.33v-.804a2.83 2.83 0 0 1 1.248-.306zM22 11v2H7v-2zM3.938 3.698V8h-.942V4.82L2 5.156v-.552l1.272-.906zM22 5v2H7V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNumberList as NumberList };
